import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Particle from "../Particle";
import Resumecontent from "./ResumeContent";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import pdf from "../../Assets/mansoor majeed biodata.pdf";

function Resume() {
  const uri = "https://porfolio-backend.vercel.app/ranks/getRanks";
  const [ upadteSpojRank] = useState(0);
  const [ upadteHackerank] = useState(0);
  const [ upadateSem] = useState(0);
  const [ upadteCgpa] = useState(0);

  useEffect(() => {
    axios
      .get(uri)
      .then((res) => {
        upadteSpojRank(res.data.message[0].spojRank);
        upadteHackerank(res.data.message[1].hackerrank);
        upadteCgpa(res.data.message[2].cgpa);
        upadateSem(res.data.message[3].sem);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <Container fluid className="resume-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <i className="fas fa-download">&nbsp;</i>Download CV
          </Button>
        </Row>
        <Row className="resume">
          <Col md={6} className="resume-left">
           
            <h3 className="resume-title">Extracurricular Activities</h3>
            <Resumecontent
              title="FOOTBALL and CRICKET player"
              content={[
                "currenty playing football for EAGLES FC parambayam as a goal keeper",
                "plays CRICKET for a local club named YORKERS ELEVENS as a wicket keeper Batsman. ",
              ]}
            />
            <Resumecontent
              title="SCIENCE FEST"
              content={[
                "I participated lots of fest and projects related to science, computer science and Mathematics.",
              ]}
            />
          </Col>
          <Col md={6} className="resume-right">
            <h3 className="resume-title">Education</h3>
            <Resumecontent
              title="COMPUTER SCIENCE ENGINEERING [KMEA Engg. Collage , KOCHI] "
              date="2020 - Present"
              content={[`Loading....!`]}
            />
            <Resumecontent
              title="12TH BOARD [Vidyadhiraja vidyabhavan EHS School,ALUVA]"
              date="2018 - 2020"
              content={["Precentage: 83%"]}
            />
            <Resumecontent
              title="10TH BOARD [Vidyadhiraja vidyabhavan EHS School,ALUVA] "
              date="2010 - 2018"
              content={["Precentage: 99%"]}
            />
            <h3 className="resume-title">Ranks and Achivements</h3>
            <Resumecontent
              title=""
              content={[
                "Loading.....!"
              ]}
            />
          </Col>
        </Row>
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button variant="primary" href={pdf} target="_blank">
            <i className="fas fa-download">&nbsp;</i>Download CV
          </Button>
        </Row>
      </Container>
    </Container>
  );
}

export default Resume;

